import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetSpecificRowNote = createAsyncThunk(
  "GetSpecificRowNote/GetSpecificRowNote",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data.filter((item) => item.incrementNumber - 1 === 1);
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneSpecificRowNote = createSlice({
  name: "OneSpecificRowNote ",
  initialState: {
    OneSpecificRowNote: {},
    loadingOneSpecificRowNote: false,
    errorOneSpecificRowNote: null,
  },


  extraReducers: (builder) => {
    builder
      .addCase(GetSpecificRowNote.pending, (state, action) => {
        state.loadingOneSpecificRowNote = true;
        state.OneSpecificRowNote = action.payload;
        state.errorOneSpecificRowNote = null;
      })
      .addCase(GetSpecificRowNote.fulfilled, (state, action) => {
        state.loadingOneSpecificRowNote = false;
        state.OneSpecificRowNote = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowNote.rejected, (state, action) => {
        state.loadingOneSpecificRowNote = false;
        state.errorOneSpecificRowNote = action.payload;
      });
  },
});
export const { SpecificNote } = OneSpecificRowNote.actions;
export default OneSpecificRowNote.reducer;
